import generateFilterForQuery from './common/_tools';

export class ShiftsListPageQuery {

  static build(query: any, pathData: any = {}, by_delivery: boolean = false) {

    const filter = generateFilterForQuery(query);

    let sw_join: any = 'left'

    if (query.master || query.operator) {
      const eids = []
      if(!query.operator) {
        filter.push({ $eq: ['vr.is_manager', { $: true }] })
      } else {
        eids.push(query.operator)
      }
      if (query.master) {
        eids.push(query.master)
      }

      filter.push({ $in: ['sw.employee_id', { $: eids}] })
      sw_join  = null
    }

    if (query.template) {
      filter.push({ $eq: ['shift.templates', { $: query.template }] })
    }
    if (query.since) {
        filter.push({ "$gte": ["shift.shift_date", {"$": query.since}] })
    }
    if (query.until) {
        filter.push({ "$lte": ["shift.shift_date", {"$": query.until}] })
    }

    return {
      columns: ShiftsListPageQuery.COLUMNS,
      from: ShiftsListPageQuery.FROM,
      from_as: ShiftsListPageQuery.FROM_AS,
      joins: [
        {
          join: 's:employees',
          type: 'left',
          as:   'created_employee',
          on: {
            $eq: ['shift.manager_id', 'created_employee.id']
          }
        },
        {
          join: 's:voc_lines',
          type: 'left',
          as:   'line',
          on: {
            $eq: ['shift.line_id', 'line.id']
          }
        },
        {
          join: 's:shift_workers',
          type: sw_join,
          as:   'sw',
          on:   {$eq: ['sw.shift_id', 'shift.id']}
        },
        {
          join: 's:voc_roles',
          type: sw_join,
          as:   'vr',
          on:   {$eq: ['sw.role_id', 'vr.id']}
        },
        {
          join: 's:employees',
          type: sw_join,
          as:   'workers',
          on:   {$eq: ['sw.employee_id', 'workers.id']}
        },
      ],
      groups: ShiftsListPageQuery.GROUPS,
      page_size: ShiftsListPageQuery.PAGE_SIZE,
      ...({page: parseInt(query.page) || 1}),
      ...({
          order: [
              by_delivery ? { $desc: [ ShiftsListPageQuery.COLUMNS['id'] ] } : query.sortDirection == 'desc' ? { $desc_nulls_last: [ShiftsListPageQuery.COLUMNS[query.sortField || 'created_at' ]] } : { $asc: [ShiftsListPageQuery.COLUMNS[query.sortField || 'created_at']] },
              { $asc: [ 'shift.id' ] }
          ]
      }),
      ...(
          filter.length > 1 ?
          {
              "where": {
                  "$and": filter
              }
          } : {
              "where": filter[0]
          }
      ),
      ...pathData
    }
  }

  static COLUMNS: any = {
    id: 'shift.id',
    shift_date: 'shift.shift_date',
    times_of_day: 'shift.times_of_day',
    begin_time: 'shift.begin_time',
    end_time: 'shift.end_time',
    real_begin_time: 'shift.real_begin_time',
    real_end_time: 'shift.real_end_time',
    close_state: 'shift.close_state',
    created_at: 'shift.created_at',
    updated_at: 'shift.updated_at',
    template: 'shift.templates',
    line_name: 'line.name',
    total_workers: {$count: 'sw.id'},
    workers: {
      $array_agg:
        { $obj: {
          employee_name: 'workers.name',
          is_manager: 'vr.is_manager'
        }
      }
    }
  };

  static FROM: string = 's:shifts';
  static FROM_AS: string = 'shift';

  static GROUPS: any[] = [
    'shift.id', 'line.name',
  ]

  static PAGE_SIZE: number = 100

}
